export default 0.03111531889246;
